/* Lumir · "Arma tu combo": desde la página del producto el cliente elige varios perfumes de 100 ml (dama, hombre o unisex),
   ve el precio del combo y con "Pedir mi combo" los lleva al carrito y se abre el formulario de Releasit.
   Los precios de combo los cobran los descuentos automáticos "Combo N perfumes 100 ml"; aquí solo se muestran. */
(() => {
  if (window.lumirCombo) return;
  window.lumirCombo = true;

  const precio = n => n <= 1 ? 129000 * n : n === 2 ? 169000 : n === 3 ? 199000 : 60000 * n;
  const peso = n => '$' + n.toLocaleString('es-CO');
  const normal = s => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const GENEROS = { T: 'Todos', D: 'Dama', H: 'Hombre', U: 'Unisex' };
  const VISIBLES = 40;

  let lista = null, elegidos = [], filtro = 'T', busqueda = '', mostrar = VISIBLES, hoja;

  // Toda la tienda en pocas peticiones livianas (ver templates/collection.combo.liquid).
  const cargar = async () => {
    if (lista) return lista;
    const todos = [];
    for (let pagina = 1, paginas = 1; pagina <= paginas; pagina++) {
      const r = await (await fetch(`/collections/all?view=combo&page=${pagina}`)).json();
      paginas = r.paginas;
      todos.push(...r.perfumes);
    }
    return (lista = todos);
  };

  const pista = n => n === 0 ? 'Elige tus perfumes de 100 ml'
    : n === 1 ? `Agrega 1 más y llévate 2 por ${peso(169000)}`
    : n === 2 ? `Agrega 1 más y llévate 3 por ${peso(199000)}`
    : n === 3 ? `Desde 4 perfumes, cada uno a ${peso(60000)}`
    : `Cada perfume te queda en ${peso(60000)}`;

  const pintarElegidos = () => {
    const n = elegidos.length;
    hoja.querySelector('[data-elegidos]').innerHTML = elegidos.map((p, i) =>
      `<li><img src="${p.i}" alt="" width="40" height="40" loading="lazy"><span>${p.t}</span>
        <button type="button" data-quitar="${i}" aria-label="Quitar ${p.t}">✕</button></li>`).join('');
    hoja.querySelector('[data-cuenta]').textContent = n === 1 ? '1 perfume' : `${n} perfumes`;
    const ahorro = 129000 * n - precio(n);
    hoja.querySelector('[data-total]').innerHTML = ahorro > 0 ? `<s>${peso(129000 * n)}</s> ${peso(precio(n))}` : peso(precio(n));
    hoja.querySelector('[data-pista]').textContent = pista(n);
    const pedir = hoja.querySelector('[data-pedir]');
    pedir.disabled = n < 2;
    pedir.textContent = n < 2 ? 'Elige al menos 2 perfumes' : `Pedir mi combo · ${peso(precio(n))}`;
  };

  const pintarLista = () => {
    const ul = hoja.querySelector('[data-lista]');
    if (!lista) { ul.innerHTML = '<li class="lumir-combo__aviso">Cargando perfumes…</li>'; return; }
    const q = normal(busqueda.trim());
    const hallados = lista.filter(p => (filtro === 'T' || p.g === filtro) && (!q || normal(p.t).includes(q)));
    ul.innerHTML = hallados.slice(0, mostrar).map(p => {
      const veces = elegidos.filter(e => e.v === p.v).length;
      return `<li><img src="${p.i}" alt="" width="56" height="56" loading="lazy"><span>${p.t}</span>
        <button type="button" data-agregar="${p.v}">${veces ? `+ Otro (${veces})` : '+ Agregar'}</button></li>`;
    }).join('') || '<li class="lumir-combo__aviso">No encontramos ese perfume. Prueba con otra palabra.</li>';
    if (hallados.length > mostrar) ul.insertAdjacentHTML('beforeend', '<li class="lumir-combo__mas"><button type="button" data-mas>Ver más perfumes</button></li>');
  };

  const crearHoja = () => {
    hoja = document.createElement('div');
    hoja.className = 'lumir-combo__fondo';
    hoja.hidden = true;
    hoja.innerHTML = `
      <div class="lumir-combo__hoja" role="dialog" aria-modal="true" aria-labelledby="lumir-combo-titulo">
        <header class="lumir-combo__cabeza">
          <h2 id="lumir-combo-titulo">Arma tu combo</h2>
          <button type="button" class="lumir-combo__cerrar" data-cerrar aria-label="Cerrar">✕</button>
          <p>2 por ${peso(169000)} · 3 por ${peso(199000)} · 4 o más a ${peso(60000)} c/u · Mezcla como quieras</p>
        </header>
        <ul class="lumir-combo__elegidos" data-elegidos></ul>
        <div class="lumir-combo__filtros">
          <input type="search" placeholder="Busca tu perfume" aria-label="Buscar perfume" data-buscar>
          <div role="tablist">${Object.entries(GENEROS).map(([k, v]) => `<button type="button" role="tab" data-filtro="${k}" aria-selected="${k === 'T'}">${v}</button>`).join('')}</div>
        </div>
        <ul class="lumir-combo__lista" data-lista></ul>
        <footer class="lumir-combo__pie">
          <div><span data-cuenta></span><strong data-total></strong></div>
          <p data-pista></p>
          <button type="button" class="button" data-pedir>Pedir mi combo</button>
        </footer>
      </div>`;
    document.body.append(hoja);

    hoja.addEventListener('click', e => {
      if (e.target === hoja) return cerrar();
      const b = e.target.closest('button');
      if (!b) return;
      if (b.dataset.cerrar !== undefined) cerrar();
      else if (b.dataset.agregar) { elegidos.push(lista.find(p => p.v === Number(b.dataset.agregar))); pintarElegidos(); pintarLista(); }
      else if (b.dataset.quitar) { elegidos.splice(Number(b.dataset.quitar), 1); pintarElegidos(); pintarLista(); }
      else if (b.dataset.filtro) {
        filtro = b.dataset.filtro; mostrar = VISIBLES;
        hoja.querySelectorAll('[data-filtro]').forEach(t => t.setAttribute('aria-selected', t === b));
        pintarLista();
      }
      else if (b.dataset.mas !== undefined) { mostrar += VISIBLES; pintarLista(); }
      else if (b.dataset.pedir !== undefined) pedir(b);
    });
    // Al buscar se busca en todos los géneros, para no esconder un perfume por la pestaña que quedó activa.
    hoja.querySelector('[data-buscar]').addEventListener('input', e => {
      busqueda = e.target.value; mostrar = VISIBLES;
      if (busqueda.trim()) { filtro = 'T'; hoja.querySelectorAll('[data-filtro]').forEach(t => t.setAttribute('aria-selected', t.dataset.filtro === 'T')); }
      pintarLista();
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !hoja.hidden) cerrar(); });
  };

  const abrir = async boton => {
    if (!hoja) crearHoja();
    const actual = { t: boton.dataset.t, v: Number(boton.dataset.v), i: boton.dataset.i, g: boton.dataset.g };
    if (!elegidos.length) elegidos = [actual];
    hoja.hidden = false;
    document.documentElement.classList.add('lumir-combo-abierto');
    pintarElegidos(); pintarLista();
    try { await cargar(); } catch { hoja.querySelector('[data-lista]').innerHTML = '<li class="lumir-combo__aviso">No pudimos cargar los perfumes. Revisa tu conexión e intenta de nuevo.</li>'; return; }
    pintarLista();
  };

  const cerrar = () => { hoja.hidden = true; document.documentElement.classList.remove('lumir-combo-abierto'); };

  // El carrito queda solo con el combo elegido y se abre el formulario de Releasit desde la página del carrito.
  const pedir = async boton => {
    boton.disabled = true; boton.textContent = 'Preparando tu combo…';
    const items = Object.values(elegidos.reduce((a, p) => ((a[p.v] = a[p.v] || { id: p.v, quantity: 0 }).quantity++, a), {}));
    try {
      await fetch('/cart/clear.js', { method: 'POST' });
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
      if (!r.ok) throw new Error();
      location.href = '/cart?lumir_combo=1';
    } catch {
      boton.disabled = false; boton.textContent = 'No se pudo agregar. Intenta de nuevo';
    }
  };

  document.addEventListener('click', e => { const b = e.target.closest('[data-lumir-combo]'); if (b) abrir(b); });

  // Un solo carrito: en la ficha, "COMPRAR AHORA" de Releasit solo compra el perfume que se está viendo y deja por fuera lo
  // que ya hay en el carrito (dos pedidos sueltos no suman combo). Si el carrito tiene algo, se agrega este perfume (si no
  // estaba) y se abre el formulario con todo el carrito. Con el carrito vacío, Releasit sigue igual.
  if (/\/products\//.test(location.pathname)) {
    let dejarPasar = false;
    window.addEventListener('click', async e => {
      const boton = e.target.closest('#rsi_buy_now_button');
      if (!boton || dejarPasar || boton.closest('cart-drawer, #CartDrawer')) return;
      e.preventDefault(); e.stopImmediatePropagation();
      let carrito = null;
      try { carrito = await (await fetch('/cart.js')).json(); } catch {}
      if (!carrito?.item_count) { dejarPasar = true; boton.click(); dejarPasar = false; return; }
      const form = document.querySelector('form[action*="/cart/add"]:not(cart-drawer form):has([name=id])');
      const id = Number(form?.querySelector('[name=id]')?.value);
      try {
        if (id && !carrito.items.some(i => i.variant_id === id)) {
          const cantidad = Number(form.querySelector('[name=quantity]')?.value) || 1;
          const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: cantidad }] }) });
          if (!r.ok) throw new Error();
        }
        location.href = '/cart?lumir_combo=1';
      } catch { dejarPasar = true; boton.click(); dejarPasar = false; }
    }, true);
  }

  // En el carrito, al llegar desde "Pedir mi combo", se abre solo el formulario de Releasit. Su botón aparece antes de
  // que Releasit termine de cargar y un toque temprano no hace nada, así que se toca cada segundo hasta que abra (máx. 15 s).
  if (location.pathname === '/cart' && new URLSearchParams(location.search).has('lumir_combo')) {
    let intentos = 0;
    const tocar = setInterval(() => {
      if (document.querySelector('form:has(.rsi-submit_button)') || ++intentos > 15) return clearInterval(tocar);
      [...document.querySelectorAll('#rsi_buy_now_button')].find(x => !x.closest('#floatingBuyNowButton'))?.click();
    }, 1000);
  }
})();
